(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kurashi-denim-motion-hero"] && !Shopify.designMode) return;
  try {
    
if (!window.kurashiDenimHeroInit) {
  window.kurashiDenimHeroInit = function(root) {
    root.querySelectorAll('.kdm').forEach(hero => {
      if (hero.dataset.initialized) return;
      hero.dataset.initialized = 'true';
      const button = hero.querySelector('.kdm__pause');
      if (!button) return;
      button.hidden = false;
      button.addEventListener('click', () => {
        const paused = hero.dataset.paused !== 'true';
        hero.dataset.paused = String(paused);
        button.setAttribute('aria-pressed', String(paused));
        button.textContent = paused ? button.dataset.play : button.dataset.pause;
      });
    });
  };
  document.addEventListener('shopify:section:load', event => window.kurashiDenimHeroInit(event.target));
}
window.kurashiDenimHeroInit(document);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kurashi-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kurashi-reviews')) {
  customElements.define('kurashi-reviews', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.kb-reviews__track');
      if (!this.track) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.controls = this.querySelector('.kb-reviews__controls');
      this.buttons = [...this.controls.querySelectorAll('button')];
      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.controls.hidden = max < 3;
        this.buttons[0].disabled = this.track.scrollLeft < 3;
        this.buttons[1].disabled = this.track.scrollLeft >= max - 3;
      };
      this.buttons.forEach(button => button.addEventListener('click', () => {
        const card = this.track.querySelector('article');
        const step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap) : this.track.clientWidth;
        this.track.scrollBy({left: Number(button.dataset.direction) * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }, {signal}));
      this.track.addEventListener('scroll', this.update, {passive:true,signal});
      this.addEventListener('shopify:block:select', event => {
        if (this.track.contains(event.target)) {
          const card = event.target.closest('article');
          if (card) this.track.scrollTo({left:card.offsetLeft-this.track.querySelector('article').offsetLeft,behavior:'instant'});
        }
      }, {signal});
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
